export default class ObjectModule {
}
